import { render, staticRenderFns } from "./fAddress.template?vue&type=template&id=31d83773&scoped=true&lang=pug&"
import script from "./fAddress.client?vue&type=script&lang=ts&"
export * from "./fAddress.client?vue&type=script&lang=ts&"
import style0 from "./fAddress.component.vue?vue&type=style&index=0&id=31d83773&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d83773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d83773')) {
      api.createRecord('31d83773', component.options)
    } else {
      api.reload('31d83773', component.options)
    }
    module.hot.accept("./fAddress.template?vue&type=template&id=31d83773&scoped=true&lang=pug&", function () {
      api.rerender('31d83773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fAddress/fAddress.component.vue"
export default component.exports